import {
  save,
  get
} from '@/services/config/security'

export default {
  namespace: 'security',
  state: {
  },

  effects: {
    *save({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },
    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (callback) callback(response);
    },
  },

  reducers: {

  },
};
